import { render, staticRenderFns } from "./DoctorDeta.vue?vue&type=template&id=836201a4&scoped=true"
import script from "./DoctorDeta.vue?vue&type=script&lang=js"
export * from "./DoctorDeta.vue?vue&type=script&lang=js"
import style0 from "./DoctorDeta.vue?vue&type=style&index=0&id=836201a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836201a4",
  null
  
)

export default component.exports